import { render } from "./ConversationSharedFiles.vue?vue&type=template&id=d5387722&ts=true"
import script from "./ConversationSharedFiles.ts?vue&type=script&lang=ts&external"
export * from "./ConversationSharedFiles.ts?vue&type=script&lang=ts&external"

import "./ConversationSharedFiles.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__